import { Icon } from "./Icon.tsx";

/**
 * "Delete this one series" icon — deliberately NOT TrashIcon.tsx, even
 * though the action is also a real deletion: real confusion reported live,
 * this button sits right next to (and, once made icon-only/compact, close
 * to) a sub-basin/aquifer's own "Delete permanently" button, which already
 * uses TrashIcon everywhere else in the app — same icon for both read as
 * "these do the same amount of damage" and made it easy to click the wrong
 * one. This one only clears a single series column, not the whole entity.
 */
export function EraserIcon() {
  return (
    <Icon>
      <path d="M4 20h16" />
      <path d="M8 16l7-7 4 4-7 7H8z" />
      <path d="M12.5 11.5l4 4" />
    </Icon>
  );
}
